var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyVoucher(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.07915 23.3855C3.08785 25.0423 4.43801 26.3773 6.09484 26.3673L28.0314 26.2345C29.6882 26.2245 31.0243 24.8733 31.0156 23.2164L31.0052 21.2412C30.9826 21.2416 30.9598 21.2419 30.9371 21.2419C28.8799 21.2419 27.2122 19.451 27.2122 17.2419C27.2122 15.0327 28.8799 13.2419 30.9371 13.2419C30.9458 13.2419 30.9545 13.2419 30.9633 13.242L30.9521 11.1166C30.9434 9.4598 29.5932 8.1248 27.9364 8.13482L5.99987 8.26755C4.34305 8.27757 3.00697 9.62882 3.01567 11.2857L3.02593 13.2419C5.07131 13.2568 6.72513 15.0419 6.72513 17.2419C6.72513 19.4267 5.09388 21.2024 3.0679 21.2412L3.07915 23.3855Z",
    fill: "current"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.2188,
    y: 19.6797,
    width: 3,
    height: 3,
    rx: 1.5,
    fill: "#03C6AE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 11.2422,
    width: 3,
    height: 3,
    rx: 1.5,
    fill: "#03C6AE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 22.5732,
    width: 12.6562,
    height: 1.40625,
    rx: 0.703125,
    transform: "rotate(-63.5394 17 22.5732)",
    fill: "#FFB81E"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 8.24219,
    width: 1,
    height: 2,
    rx: 0.5,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 11.4424,
    width: 1,
    height: 2,
    rx: 0.5,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 14.6426,
    width: 1,
    height: 2,
    rx: 0.5,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 17.8428,
    width: 1,
    height: 2,
    rx: 0.5,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 21.043,
    width: 1,
    height: 2,
    rx: 0.5,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 24.2432,
    width: 1,
    height: 2,
    rx: 0.5,
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyVoucher);
export default __webpack_public_path__ + "static/media/my-voucher.54ca5c11b2a085a95f6c39e073b4df80.svg";
export { ForwardRef as ReactComponent };